/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Home from "./Home"
import ModalReconocimiento from "./ModalReconocimiento"
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import toastr from 'toastr';
import { Segment} from 'semantic-ui-react';
import withRouter from '../common/withRouter';
import ModalDatosInstructor from '../instructor/ModalDatosInstructor';
import * as menuActions from '../../actions/menuActions'; 
import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import {getMargenes} from '../../util/';
import {genericFormattedForDropdown} from '../../selectors/selectors';


import * as infoActions from '../../actions/infoActions';

class ManageHome extends React.Component {

    // 0, valor por default 1, sin pago requerido 2, pago requerido.
    constructor(props, context){
		super(props, context);
		this.state={
            strings:{},
            constancia:{correo:null,identificacion:null },
            showModal:false,
            showModalInstructor:false,
            modalInstructor:{img:""},
            cursosConstancias:[],
            datosValidacion:{},
            descargarConstancia:0,
            cursoPago:{
                id:0,
                price:0,
                descripcion:null
            },
            pago:{}
            
        }
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "home",false);

        //console.log(this.props);
        if(this.props.user==null){
            
            let pageInfo={
                page:"home",
                idioma:this.props.idioma
            };
            this.props.infoActions.getInfo(pageInfo).then( (paginaInfo)=>{
                
                    //console.log(paginaInfo);
                
                    this.setState({strings: paginaInfo.strings});
                  })
            .catch(error=>{
              toastr.error(error);
            }); 
            
        }
        
        this.props.infoActions.getCursosCarrusel().then( ()=>{
          
                  })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        this.props.infoActions.getHomeInfo().then( ()=>{
          
                  })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        this.props.infoActions.getCursosGratuitos().then( ()=>{
          
                  })
        .catch(error=>{
          toastr.error(error);
        }); 
        
     
        
        this.props.infoActions.getStaff().then( ()=>{
          
                  })
        .catch(error=>{
          toastr.error(error);
        }); 
        
         this.props.infoActions.getPreguntasFrecuentes().then( ()=>{
          
                  })
        .catch(error=>{
          toastr.error(error);
        }); 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(false);
    }

    


     
    onValidar=()=>{
        console.log(this.state.constancia);
        this.props.infoActions.validaDatos(this.state.constancia).then( (datosValidados)=>{

            console.log(datosValidados);
            
             let cursoPago = this.state.cursoPago;
             let descargarConstancia = this.state.descargarConstancia; 
            
            this.setState({datosValidacion:datosValidados});
            
             if(datosValidados.id!=null){
            
                 if(datosValidados.requierePago == "1"){

                     if(datosValidados.referencia==null){
                        descargarConstancia=1;

                         cursoPago.price = Number(datosValidados.montoPago).toFixed(2);

                        cursoPago.descripcion = datosValidados.curso;
                         
                        cursoPago.reference_id = datosValidados.id;
                        cursoPago.idInscripcion = datosValidados.id;

                         this.setState({cursoPago:cursoPago});

                        console.log(cursoPago);
                        

                     }else{
                         descargarConstancia=3;
                     } 

                 }else{
                    descargarConstancia=3;
                 }
                 
                 
             }else{
                 toastr.error("No se tiene registrada la información proporcionada");
                 descargarConstancia=0;
             }
            console.log(descargarConstancia);
            this.setState({descargarConstancia:descargarConstancia});
            
             
            
             
            
        })
         .catch(error=>{
          toastr.error(error);
        });
        
        
    } 
    
    
    
    handleApprove = (orderID, order)=>{
    //handleApprove = (datosValidados)=>{
        //console.log("handrleApprove");
        //console.log(datosValidados);
            let pago = this.state.pago;
            pago.id =this.state.datosValidacion.id;
            pago.referencia = order.purchase_units[0].payments.captures[0].id;
            pago.cadena = Object.assign({},order);
            pago.cadena=JSON.stringify(pago.cadena);
            //pago.id = datosValidados.id;    
            //pago.cadena="cadena de prueba";
            //console.log(pago);
            
            this.props.infoActions.savaPagoConstancia(pago).then(() => {
                toastr.success("Pago registrado!!!.");
                this.onValidar();
                   
            }).catch(error=>{
                toastr.error(error);
            });
            
    }
     
    onDescargar=()=>{
        
        
          this.props.infoActions.validaDatos(this.state.constancia).then( (datos)=>{
            
            //  if(datos.id!=null){
            //      if(datos.requierePago==1){
            //          alert("requierepago");
            //      }else{
                      window.open("/info/reconocimientoManual?id="+datos.identificacion+"&correo="+datos.correo+"&clave="+datos.claveCurso);
            //      }
            //  }else{
            //      toastr.error("No se tiene registrada la información proporcionada");
            //  }
              
              
              
            
        })
         .catch(error=>{
            toastr.error(error);
        });
        
        
    }
     
     onShowModal=()=>{
         let  descargarConstancia= this.state.descargarConstancia;
         
        if(this.state.cursosConstancias.length==0) 
        this.props.infoActions.getCursosConstancias().then( (datos)=>{
            this.setState({cursosConstancias:datos});
                  
               
        })
         .catch(error=>{
          toastr.error(error);
        });
          
         
        let showModal = this.state.showModal;
         if(showModal){
             showModal=false
             descargarConstancia = 0;
             this.setState({descargarConstancia:descargarConstancia});
             
             
         }else{
             showModal=true;
         }
         this.setState({showModal:showModal});
     }
     
     onShowModalInstructor=(idInstructor)=>{
         
         
        let showModalInstructor = this.state.showModalInstructor;
         let indexInstructores = this.props.instructores.findIndex(inst=>inst.id==idInstructor); 
         
         let modalInstructor = this.props.instructores[indexInstructores];
         
         
             showModalInstructor=true;
         this.setState({showModalInstructor:showModalInstructor,modalInstructor:modalInstructor});
     }
     
     onCloseModalInstructor=()=>{
        let showModalInstructor = this.state.showModalInstructor; 
        showModalInstructor=false;
        this.setState({showModalInstructor:showModalInstructor});
         
     }
     
      handleChange=(event, data)=> {

        let constancia = this.state.constancia;
        let  descargarConstancia= this.state.descargarConstancia;
        descargarConstancia = 0;
       
          
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		constancia[field[0]]= value;
		else{
             if(!constancia[field[0]]){
                    constancia[field[0]]={}
                }
			constancia[field[0]][field[1]]= value;
		}
        
		
        this.setState({"constancia": constancia});
        this.setState({descargarConstancia:descargarConstancia});
    }
      
      
      
       
    render() {	
      let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);    
       return (
           <Segment  basic style={margenes}>
             <Home 
                idioma={this.props.idioma}
                strings={this.props.strings}
                user={this.props.user}
                content={this.state.content} 
                datos={this.props.cursoCarrusel}
                gratuitos={this.props.cursoGratuitos}
                faq={this.state.faq}
                homeInfo={this.props.homeInfo}
                instructores={this.props.instructores}
                preguntasFrecuentes={this.props.preguntasFrecuentesHome}
                handleApprove={this.handleApprove}
                onShowModal={this.onShowModal}
                onShowModalInstructor={this.onShowModalInstructor}
           />

           <ModalReconocimiento
                showModal={this.state.showModal}
                closeModal={this.onShowModal}
                icono="user"
                download={this.onDescargar}
                onValidar={this.onValidar}
                texto="Descargar constancia"
                titulo="Constancias"
                strings={this.props.strings}
                datos={this.state.constancia}
                cursoPago={this.state.cursoPago}
                onChange={this.handleChange}
                cursosConstancias={genericFormattedForDropdown(this.state.cursosConstancias)}
                descargarConstancia={this.state.descargarConstancia}
                datosValidacion={this.state.datosValidacion}
                handleApprove={this.handleApprove}
           />
           
           <ModalDatosInstructor
                showModal={this.state.showModalInstructor}
                closeModal={this.onCloseModalInstructor}
                modalInstructor={this.state.modalInstructor}
                
           />
           
           </Segment>
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {  
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        ajaxCallInProgress:state.ajaxCallInProgress,
        cursoCarrusel:state.cursoCarrusel,
        cursoGratuitos:state.cursoGratuitos,
        idioma:state.idioma,
        homeInfo:state.homeInfo,
        instructores:state.instructores,
        preguntasFrecuentesHome:state.preguntasFrecuentesHome,
        user:state.user,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions: bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),

  };
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageHome));